import * as ko from "knockout";
import type { Lang, Localized, Section, LocalizedTemplate, RootVm, EmailTemplateVM } from "../types";

declare const notyf: any;

export type QuickMessageParams = {
    rootvm: RootVm;
};

export class QuickMessageTemplateVM implements EmailTemplateVM {
    type = "QuickMessageTemplate";
    rootvm: RootVm;

    language = ko.observable<Lang>("de");

    subject = ko.observable<string>("");
    hi = ko.observable<string>("");
    greetings = ko.observable<string>("");
    subject_template = ko.observable<Localized>({ de: "", en: "", fr: "" });
    hi_template = ko.observable<Localized>({ de: "", en: "", fr: "" });
    greetings_template = ko.observable<Localized>({ de: "", en: "", fr: "" });

    sections: ko.ObservableArray<Section>;

    person_uuid = ko.observable<string>("");
    recipient_name = ko.observable<string>("");
    display_name = ko.observable<string>("");

    constructor(params: QuickMessageParams) {
        this.rootvm = params.rootvm;

        this.sections = ko.observableArray<Section>([this.makeSection("Message", 10)]);

        this.language.subscribe((lang) => {
            if (lang) this.populate(lang);
        });
    }

    private makeSection(label: string, rows: number): Section {
        return {
            label,
            value: ko.observable<string>(""),
            template: ko.observable<Localized>({ de: "", en: "", fr: "" }),
            rows,
        };
    }

    private buildTemplate(): LocalizedTemplate {
        const recipient = this.recipient_name();
        const display = this.display_name();

        return {
            subject: { de: "", en: "", fr: "" },
            hi: {
                de: `*Hey ${recipient}*,`,
                en: `*Hey ${recipient}*,`,
                fr: `*Salut ${recipient}*,`,
            },
            sections: [
                { de: "", en: "", fr: "" },
            ],
            greetings: {
                de: `Liebe Grüße\n*${display}*`,
                en: `Best regards\n*${display}*`,
                fr: `Cordialement\n*${display}*`,
            },
        };
    }

    populate = (language: Lang = this.language()) => {
        const tpl = this.buildTemplate();

        this.subject_template(tpl.subject);
        this.hi_template(tpl.hi);
        this.greetings_template(tpl.greetings);

        tpl.sections.forEach((localized, i) => {
            const section = this.sections()[i];
            if (!section) return;
            section.template(localized);
            section.value(localized[language] ?? "");
        });

        this.subject(tpl.subject[language] ?? "");
        this.hi(tpl.hi[language] ?? "");
        this.greetings(tpl.greetings[language] ?? "");
    };

    send_mail = () => {
        const data = {
            subject: this.subject(),
            hi: this.hi(),
            sections: this.sections().map((s) => s.value()),
            greetings: this.greetings(),
            person_uuid: this.person_uuid(),
            locale: this.language(),
        };
        return fetch("/api/admin/person/send-quick-message", {
            method: "POST",
            body: JSON.stringify(data),
        })
            .then((r) => r.json())
            .then(() => notyf.success("Message sent."));
    };
}
